import React from 'react';
import FooterContact from './FooterContact';
import FooterInfo from './FooterInfo';
import FooterMentionLegales from './FooterMentionLegales';

const Footer = () => (
  <footer className="site-footer">
    <FooterContact />
    <FooterInfo />
    <FooterMentionLegales />
  </footer>
);

export default Footer;
